export default __webpack_public_path__ + "static/media/gallery-14-2.db38d492.webp";